import {notEmpty} from '@wandb/weave/common/util/obj';
import {pick} from 'lodash';
import {useMemo} from 'react';

import {
  type RunSelectorAutoColsRunsQueryVariables,
  useRunSelectorAutoColsRunsQuery,
} from '../../../generated/graphql';
import {propagateErrorsContext} from '../../../util/errors';
import * as Filters from '../../../util/filters';
import * as Run from '../../../util/runs';
import {type RunSelectorRunsPartialVars} from '../types';

const AUTO_COLS_RUNS_LIMIT = 500;

export const useAutoColsRuns = (
  topLevelQueryVariables: RunSelectorRunsPartialVars
) => {
  const queryVariables = useMemo(() => {
    const passThroughVars = pick(topLevelQueryVariables, [
      'enableArtifactCounts',
      'entityName',
      'groupLevel',
      'order',
      'projectName',
    ]);
    const {filters, grouping} = topLevelQueryVariables;
    const groupKeys = Run.groupingToServerGroupKeys(
      grouping ?? [],
      'useAutoColsRuns'
    );
    const variables: RunSelectorAutoColsRunsQueryVariables = {
      ...passThroughVars,
      filters: JSON.stringify(Filters.toMongo(filters)),
      groupKeys,
      limit: AUTO_COLS_RUNS_LIMIT,
    };
    return variables;
  }, [topLevelQueryVariables]);

  const {loading, data} = useRunSelectorAutoColsRunsQuery({
    context: propagateErrorsContext(),
    variables: queryVariables,
    fetchPolicy: 'no-cache',
  });

  const runs = useMemo(
    () =>
      data?.project?.runs?.edges
        ?.map(({node}) => Run.fromJson(node))
        .filter(notEmpty) ?? [],
    [data?.project?.runs?.edges]
  );

  return {
    isLoading: loading,
    runs,
  };
};
